module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-car-photo-admin"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-dark"
  }, [_c('h4', {
    staticClass: "car-name"
  }, [_vm._v(_vm._s(_vm.car.brand))]), _vm._v(" " + _vm._s(_vm.car.model) + " (" + _vm._s(_vm.car.year) + ")\n      ")]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('clearfix', {
    attrs: {
      "wide": true
    }
  }), _vm._v(" "), _c('div', [_c('form', [_c('label', {
    attrs: {
      "for": "new-photo"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.form.photo')) + ": ")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "new-photo",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onPhotoFileChange
    }
  }), _vm._v("\n             \n            "), _c('b-button', {
    attrs: {
      "size": 'sm',
      "variant": 'secondary'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.uploadPhoto($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "check-circle"
    }
  }), _vm._v(" \n              " + _vm._s(_vm.$t('message.button.save')) + "\n            ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('loading-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.savingImage),
      expression: "savingImage"
    }]
  })], 1)], 1)]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true
    }
  })], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "wide": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.car.photos.length > 0),
      expression: "car.photos.length > 0"
    }],
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('gallery', {
    attrs: {
      "images": _vm.preparePhotos(true),
      "index": _vm.index
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  }), _vm._v(" "), _vm._l((_vm.preparePhotos()), function(photo, photoIndex) {
    return _c('div', {
      key: photoIndex,
      staticClass: "gallery-photo",
      style: ({
        backgroundImage: 'url(\'' + _vm.$t(_vm.imageBase, {
          car_id: _vm.car.id,
          file_name: photo
        }) + '\')',
        width: '300px',
        height: '200px'
      }),
      on: {
        "click": function($event) {
          _vm.index = photoIndex
        }
      }
    }, [_c('div', {
      staticClass: "gallery-photo-control",
      attrs: {
        "title": _vm.$t('message.button.delete_photo')
      },
      on: {
        "click": function($event) {
          _vm.deletePhoto(photo, $event)
        }
      }
    }, [_vm._v("x")])])
  })], 2), _vm._v(" "), _c('clearfix', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.car.photos.length > 0),
      expression: "car.photos.length > 0"
    }],
    attrs: {
      "bootstrap": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f0ebd91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/car/PhotoAdmin.vue
// module id = 1197
// module chunks = 1